export default "__VITE_ASSET__3cf458ea__"